import ConfirmationDialog from "@hudson/ui/components//Dialogs/Confirmation";
import Button from "@hudson/ui/components/FormFields/Button";
import Session from "@lib/session";
import useContent from "@lib/use_content";
import { useRouter } from "next/navigation";
import { useState } from "react";

interface TopBarProps {
  onBack?: () => void;
  className?: string;
  showBack?: boolean;
  showLogout?: boolean;
}

function TopBar({
  className = "",
  onBack,
  showBack,
  showLogout = true,
}: TopBarProps): JSX.Element | null {
  const router = useRouter();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const { data, loading } = useContent([
    "beConfirmDialogDefaultCancelButton",
    "beLogoutConfirmationMsg",
    "beLogoutButton",
    "beLogoutConfirmationButton",
    "beLogoutConfirmationTitle",
    "beRessummaryBackButton",
  ]);

  async function logout() {
    await Session.clearSession();
    router.push(`/${window.siteId}/book`);
  }

  return loading ? null : (
    <>
      <header className={`${className} relative mb-4 -mt-2 xxs:-mt-4`}>
        <nav aria-label="Top" className="mx-auto">
          <div>
            <div className="flex flex-wrap items-center justify-between pt-1 mx-2 my-2 space-x-12 text-slate-600 ">
              <div>
                {showBack && (
                  <Button
                    onClick={() => (onBack ? onBack() : router.back())}
                    textColorClass="text-gray-500"
                    asLink
                  >
                    <div className="flex space-x-2 hover:opacity-50">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
                        />
                      </svg>

                      <span>{data?.content.beRessummaryBackButton}</span>
                    </div>
                  </Button>
                )}

                {showLogout && (
                  <Button
                    onClick={() => setShowLogoutDialog(true)}
                    textColorClass="text-gray-500"
                    asLink
                    color="red"
                  >
                    <div className="flex space-x-2 hover:opacity-50">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <span>{data?.content.beLogoutButton}</span>
                    </div>
                  </Button>
                )}
              </div>

              <ConfirmationDialog
                cancelLabel={data?.content.beConfirmDialogDefaultCancelButton}
                confirmLabel={data?.content.beLogoutConfirmationButton}
                message={data?.content.beLogoutConfirmationMsg}
                onConfirm={logout}
                onHide={() => setShowLogoutDialog(false)}
                show={showLogoutDialog}
                title={data?.content.beLogoutConfirmationTitle}
              />
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}

export default TopBar;
